import {
  fetchGasBizoppDetail,
  fetchGasConfigByKeys
} from '@/api'
export default {
  async getBizoppDetailBasicById({commit, state}, params) {
    const res = await fetchGasBizoppDetail(params)
    if (res && res.data) {
      commit('updateBizoppDetailBasicInfo', res.data)
    }
    return res.data
  },
  async getGasConfigByKeys({commit, state}, params) {
    const res = await fetchGasConfigByKeys(params)
    if (res && res.data) {
      commit('updateConfigKeys', res.data)
    }
    return res.data
  }
}
